var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "border border-light py-1 px-1 mb-2 alert-fix",
      attrs: { id: "pif-xgspon-infos" },
    },
    [
      _c("h4", { staticClass: "h4 h4-fix mb-0" }, [
        _vm._v("\n        " + _vm._s(_vm.pifXgsponInfos.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "p-0 text-mw", attrs: { "data-writefontsize": "" } },
        [
          _c("strong", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.pifXgsponInfos.content) +
                "\n        "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-secondary pif-infos--collapse",
          attrs: {
            href: _vm.pifXgsponInfos.url,
            "data-oevent-category": _vm.pifXgsponInfos.buttonTms.category,
            "data-oevent-action": _vm.pifXgsponInfos.buttonTms.action,
            "data-oevent-label": _vm.pifXgsponInfos.buttonTms.label,
          },
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.pifXgsponInfos.buttonLabel) + "\n    "
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }